import { Component } from '@angular/core';
import { ShowComponent } from 'src/app/common/component/show.component';

@Component({
	selector: 'app-tourist-guides-event',
	templateUrl: './tourist-guides-event.component.html',
	styleUrls: ['./tourist-guides-event.component.css'],
})
export class TouristGuidesEventComponent extends ShowComponent {
	protected itemsBeforeDataLoad = 2;
	protected parentComponent = 'tourist-guides-calendar';
	protected apiUrl = '/touristGuidesEvents/';
	protected apiUrlAdd = '/touristGuidesEvents/';
	data = {
		id: this.route.snapshot.params['id'],
		date_from: null,
		date_to: null,
		type: null,
		touristGuides: null,
		comments: null,
		status: 1,
	};
	touristGuides: Array<any> = [];
	types: Array<any> = [];

	protected loadBefore() {
		this.api.get('/touristGuidesEventsTypes/', (result, error) => {
			this.types = result.data;
			this.loadData();
		});
		this.api.get('/touristGuides/', (result, error) => {
			this.touristGuides = result.data;
			this.loadData();
		});
	}

	protected getApiUrl(): string {
		return '/touristGuidesEvents/' + this.data.id;
	}
}
